import React from "react";
import { Card, Badge, Button } from "react-bootstrap";

const ProductCard = ({ item, onView }) => {
  const {
    name,
    brand,
    category,
    stock,
    priceUSD,
    priceNGN,
    exchangeRate,
    firstPhoto
  } = item;

  return (
    <Card
      className="h-100 border-0 shadow-sm"
      style={{
        transition: "transform .18s ease, box-shadow .18s ease",
        cursor: "pointer"
      }}
      onClick={onView}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = "scale(1.035)";
        e.currentTarget.style.boxShadow = "0 10px 32px rgba(0,0,0,0.12)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = "scale(1)";
        e.currentTarget.style.boxShadow = "0 4px 14px rgba(0,0,0,0.08)";
      }}
    >
      {/* IMAGE SECTION */}
      <div
        className="bg-light d-flex align-items-center justify-content-center position-relative"
        style={{
          height: 165,
          borderBottom: "1px solid rgba(0,0,0,0.06)"
        }}
      >
        {firstPhoto ? (
          <img
            src={firstPhoto}
            alt={name}
            style={{
              maxHeight: "100%",
              objectFit: "contain",
              padding: 10
            }}
          />
        ) : (
          <span className="text-muted small">No Image</span>
        )}

        {/* STOCK BADGE */}
        <Badge
          bg={stock > 0 ? "success" : "danger"}
          className="position-absolute"
          style={{ top: 8, right: 8, padding: "4px 8px", fontSize: "11px" }}
        >
          {stock > 0 ? "In Stock" : "Out of Stock"}
        </Badge>
      </div>

      {/* BODY */}
      <Card.Body className="d-flex flex-column">
        {/* TITLE */}
        <div className="fw-semibold small" style={{ lineHeight: "1.3" }}>
          {name}
        </div>

        {/* BRAND & CATEGORY */}
        <div className="text-muted small">{brand}</div>
        <div className="text-muted small mb-3">{category}</div>

        {/* PRICE SECTION */}
        <div
          className="p-2 rounded-3"
          style={{
            background: "#f7f9fa",
            border: "1px solid rgba(0,0,0,0.07)",
            marginBottom: 8
          }}
        >
          {priceNGN ? (
            <>
              <div className="fw-bold text-success fs-6">
                ₦{Number(priceNGN).toLocaleString("en-NG")}
              </div>

              <div className="small text-muted">
                <span className="fw-semibold text-dark">USD:</span> ${priceUSD}
              </div>

              <div className="small text-muted">
                <span className="fw-semibold text-dark">Live Rate:</span>{" "}
                ₦{exchangeRate}/$
              </div>
            </>
          ) : (
            <div className="small text-muted">Price unavailable</div>
          )}
        </div>

        {/* BUTTON */}
        <Button
          variant="primary"
          size="sm"
          className="w-100 fw-semibold mt-auto"
          style={{ cursor: "pointer" }}
          onClick={(e) => {
            e.stopPropagation();
            onView();
          }}
        >
          View details
        </Button>
      </Card.Body>
    </Card>
  );
};

export default ProductCard;
